var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinancial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 130",
    style: {
      enableBackground: "new 0 0 170 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#32324E;}\n\t.st1{fill:none;stroke:#32324E;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;stroke:#32324E;stroke-width:4;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#32324E;stroke-width:4;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#32324E;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.18,12c1.65,0,3,1.35,3,3s-1.35,3-3,3h-101c-1.65,0-3-1.35-3-3s1.35-3,3-3H121.18 M121.18,8h-101 c-3.87,0-7,3.13-7,7s3.13,7,7,7h101c3.87,0,7-3.13,7-7S125.04,8,121.18,8L121.18,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.43,22v53h-97V22H119.43 M123.43,18h-105v61h105V18L123.43,18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.43,79v6h-69c-1.65,0-3-1.35-3-3s1.35-3,3-3H89.43 M93.43,75h-73c-3.87,0-7,3.13-7,7s3.13,7,7,7h73V75 L93.43,75z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 100.52,
    y1: 111.1,
    x2: 111.22,
    y2: 97.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.43,121V92.7c0-5.9-4.8-10.7-10.7-10.7h-7.3c-1.1,0-2-0.9-2-2v-7h-12v7c0,1.1-0.9,2-2,2h-7.3 c-5.9,0-10.7,4.8-10.7,10.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,98.06c-2.08,1.72-3.27,4.25-3.27,6.94s1.19,5.22,3.27,6.94c0.46,0.38,0.73,0.95,0.73,1.54V122h31 v-9.47c0-0.51,0.19-1,0.54-1.37c1.58-1.68,2.46-3.87,2.46-6.16s-0.87-4.48-2.46-6.16c-0.35-0.37-0.54-0.86-0.54-1.37V93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.43,75.86c-6.78-0.97-12-6.82-12-13.86V36.14c6.78,0.97,12,6.82,12,13.86V75.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.43,38.69c4.66,1.65,8,6.1,8,11.31v23.31c-4.66-1.65-8-6.1-8-11.31V38.69 M142.43,34v28 c0,8.84,7.16,16,16,16V50C158.43,41.16,151.26,34,142.43,34L142.43,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.81,74c-8.79,0-15.95-7.15-15.95-15.95V46.82c1.17,0.12,2.32,0.18,3.45,0.18 c8.18,0,15.95-2.84,22.15-8.05c1.61,3.22,3.72,6.15,6.3,8.76v10.35C143.75,66.85,136.6,74,127.81,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.83,41.98c1.38,2.34,3.02,4.53,4.92,6.53v9.54c0,7.69-6.26,13.95-13.95,13.95s-13.95-6.26-13.95-13.95 v-9.08c0.49,0.02,0.97,0.03,1.45,0.03C123.14,49,130.62,46.54,136.83,41.98 M138.15,35.61c-5.87,5.8-13.94,9.39-22.84,9.39 c-1.86,0-3.68-0.17-5.45-0.47v13.53c0,9.91,8.04,17.95,17.95,17.95c9.91,0,17.95-8.04,17.95-17.95V46.87 C142.49,43.72,139.87,39.9,138.15,35.61L138.15,35.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.35,58.99L110.18,59c0,0,0,0-0.01,0c-2.8,0-5.04-2.24-5.04-5c0-2.76,2.24-5,5-5l0.29,0.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.43,51.78c-3.32-3.03-5.91-6.75-7.6-10.95c-0.25-0.62-0.79-1.08-1.45-1.21 c-0.13-0.03-0.27-0.04-0.41-0.04c-0.52,0-1.03,0.2-1.41,0.58c-5.64,5.58-13.11,8.65-21.04,8.65c-2.48,0-4.94-0.31-7.34-0.91v-2.99 c0-10.82,8.8-19.62,19.62-19.62s19.62,8.8,19.62,19.62V51.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.81,27.29c9.72,0,17.62,7.9,17.62,17.62v1.75c-1.53-2-2.79-4.21-3.75-6.57c-0.5-1.24-1.59-2.15-2.9-2.42 c-0.27-0.06-0.54-0.08-0.81-0.08c-1.04,0-2.06,0.41-2.81,1.16c-5.27,5.2-12.24,8.07-19.64,8.07c-1.8,0-3.58-0.17-5.34-0.51v-1.39 C110.19,35.19,118.09,27.29,127.81,27.29 M127.81,23.29c-11.94,0-21.62,9.68-21.62,21.62v4.51c2.95,0.9,6.09,1.39,9.34,1.39 c8.75,0,16.68-3.52,22.45-9.22c2.35,5.83,6.36,10.81,11.46,14.35V44.91C149.43,32.97,139.75,23.29,127.81,23.29L127.81,23.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.21,49.01l0.17-0.01c0,0,0,0,0.01,0c2.8,0,5.04,2.24,5.04,5c0,2.76-2.24,5-5,5l-0.29-0.02"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.43,81.5c0,6.35-5.15,11.5-11.5,11.5c-3.97,0-7.47-2.01-9.54-5.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.35,97.56c-2.66,1.69-5.81,2.66-9.18,2.66c-3.22,0-6.24-0.89-8.82-2.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.48,117c-2.73,0-4.95-2.22-4.95-4.95V86.26h9.89v25.79C101.43,114.78,99.21,117,96.48,117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.43,88.26v23.79c0,1.63-1.32,2.95-2.95,2.95s-2.95-1.32-2.95-2.95V88.26H99.43 M103.43,84.26H89.53v27.79 c0,3.84,3.11,6.95,6.95,6.95c3.84,0,6.95-3.11,6.95-6.95V84.26L103.43,84.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.37,86.89c-3.37,0-6.11-2.74-6.11-6.11V77h13.05c3.37,0,6.11,2.74,6.11,6.11v3.79H88.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.32,79c2.26,0,4.11,1.84,4.11,4.11v1.79H88.37c-2.26,0-4.11-1.84-4.11-4.11V79H95.32 M95.32,75H80.27v5.79 c0,4.48,3.63,8.11,8.11,8.11h15.05v-5.79C103.43,78.63,99.8,75,95.32,75L95.32,75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.33,32v32H64V32H69.33 M73.33,28H60v40h13.33V28L73.33,28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.28,38.67V64h-5.33V38.67H50.28 M54.28,34.67H40.95V68h13.33V34.67L54.28,34.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.81,44.38V64h-5.33V44.38H59.81 M63.81,40.38H50.47V68h13.33V40.38L63.81,40.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.76,56.76V64h-5.33v-7.24H40.76 M44.76,52.76H31.43V68h13.33V52.76L44.76,52.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 80,
    y1: 66.1,
    x2: 87.62,
    y2: 66.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 80,
    y1: 54.03,
    x2: 87.62,
    y2: 54.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 80,
    y1: 41.97,
    x2: 87.62,
    y2: 41.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 80,
    y1: 29.9,
    x2: 93.33,
    y2: 29.9
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 5,
    y1: 122,
    x2: 165,
    y2: 122
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinancial);
export default __webpack_public_path__ + "static/media/icon_financial.4f30cca721149a8fbfd9e3e03fa52177.svg";
export { ForwardRef as ReactComponent };